export default __webpack_public_path__ + "static/char-s-11-cht-ac81bc21c9410602fe7caa3ac9e42a0b.webp";